module.exports = __webpack_public_path__ + "static/media/internal_env_2_media_5.84c91660.webp";